<template>
  <div class="user-list-combox">
    <el-table :data="pageData.items" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="account_id" label="ID" width="100" />
      <el-table-column label="头像" width="60">
        <template slot-scope="scope">
          <img class="avatar" v-if="scope.row.avatar" :src="scope.row.avatar" :alt="scope.row.nickname" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column label="性别">
        <template slot-scope="scope">
          {{scope.row.gender === '2' ? '女' : '男'}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{userConfig.statusMap[scope.row.status]['title']}}
        </template>
      </el-table-column>
      <el-table-column label="产品">
        <template slot-scope="scope">
          {{appMap[scope.row.appid]}}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="时间" width="300" />
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :total="pageData.amount" :page-size="pageData.pageSize" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      ids: [],
      appMap: {
        wx1dc8ad85d20d02eb: '二货',
        wxb5c4c0d7adf90cbd: '去水印'
      }
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserListComponent.vue